import React from 'react'
export const IconSearch: React.FC = () => {
  return (
    <svg
      aria-hidden="true"
      className="w-5 h-5 text-SeabiscuitDark200ThemeColor/80"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      ></path>
    </svg>
  )
}
